import React from "react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section 
      className="relative min-h-[600px] md:min-h-[700px] lg:min-h-[800px] flex items-center overflow-hidden" 
      style={{ 
        fontFamily: '"Segoe UI", Arial, sans-serif',
        backgroundImage: 'url(/bg.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="w-full px-4 md:px-12 lg:px-20 xl:px-24 py-14 md:py-16 lg:py-20 relative z-10">
        <div className="flex items-center">
          {/* Left - Content */}
          <div className="w-full space-y-5 lg:space-y-6">
            {/* Tagline */}
            <p className="text-sm md:text-base text-slate-600 font-medium text-left">
              Find the best loan for you fast, simple, and completely online.
            </p>

            {/* Main Headline */}
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-tight text-left">
              <span className="text-slate-800">Finance That Moves</span>
              <br />
              <span className="text-blue-600">As Fast As You Do</span>
            </h1>

            {/* Body Text */}
            <p className="text-base md:text-lg text-slate-600 leading-relaxed text-left">
              Instant eligibility checks, quick approvals, and flexible loan solutions designed for modern India.
            </p>

            {/* Get Started Button */}
            <div className="pt-2">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-8 py-4 rounded-lg bg-black text-white text-base font-medium hover:bg-slate-800 transition-colors shadow-sm"
              >
                Get Started
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
            </div>

            {/* Statistics */}
            <div className="flex justify-end md:justify-center pt-20 md:pt-24 lg:pt-32 xl:pt-36">
              <div className="grid grid-cols-4 gap-4 sm:gap-6 md:gap-16 lg:gap-20 xl:gap-24 w-full max-w-7xl md:ml-8 lg:ml-16 xl:ml-24">
                <div className="text-center md:text-left">
                  <p className="text-xl sm:text-2xl md:text-3xl font-bold text-slate-800">10,000+</p>
                  <p className="text-[11px] sm:text-xs md:text-sm lg:text-base text-slate-600 mt-1 leading-snug">
                    Loans Approved
                  </p>
                </div>
                <div className="text-center md:text-left">
                  <p className="text-xl sm:text-2xl md:text-3xl font-bold text-slate-800">50+</p>
                  <p className="text-[11px] sm:text-xs md:text-sm lg:text-base text-slate-600 mt-1 leading-snug">
                    Customers Served
                  </p>
                </div>
                <div className="text-center md:text-left">
                  <p className="text-xl sm:text-2xl md:text-3xl font-bold text-slate-800">25+</p>
                  <p className="text-[11px] sm:text-xs md:text-sm lg:text-base text-slate-600 mt-1 leading-snug">
                    Years Experience
                  </p>
                </div>
                <div className="text-center md:text-left">
                  <p className="text-xl sm:text-2xl md:text-3xl font-bold text-slate-800">15+</p>
                  <p className="text-[11px] sm:text-xs md:text-sm lg:text-base text-slate-600 mt-1 leading-snug">
                    Experienced Advisors
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
